import { ContactsSearchStatuses, Search } from 'features/co-pilot/co-pilot.types';
import { useEffect, useRef, useState } from 'react';

interface SearchQuotaExceededDialogState {
  open: boolean;
  searchName: string;
  nextRetryAt: string;
}

interface Params {
  searches: Search[];
  onOpenAccountManagement: () => void;
}

const useSearchQuotaExceededDialog = ({ searches, onOpenAccountManagement }: Params) => {
  const [searchQuotaExceededDialog, setSearchQuotaExceededDialog] = useState<SearchQuotaExceededDialogState>({
    open: false,
    searchName: '',
    nextRetryAt: '',
  });
  const shownQuotaExceededSearchIdsRef = useRef<Set<string>>(new Set());

  useEffect(() => {
    const nextQuotaExceededSearch = searches.find(
      (search) =>
        search.status === ContactsSearchStatuses.QUOTA_EXCEEDED &&
        !shownQuotaExceededSearchIdsRef.current.has(search._id)
    );

    if (!nextQuotaExceededSearch) return;

    shownQuotaExceededSearchIdsRef.current.add(nextQuotaExceededSearch._id);
    setSearchQuotaExceededDialog({
      open: true,
      searchName: nextQuotaExceededSearch.name || '',
      nextRetryAt: nextQuotaExceededSearch.nextRetryAt || '',
    });
  }, [searches]);

  const handleCloseSearchQuotaExceededDialog = () => {
    setSearchQuotaExceededDialog((prev) => ({ ...prev, open: false }));
  };

  const handleOpenSearchQuotaExceededAccountManagement = () => {
    onOpenAccountManagement();
    handleCloseSearchQuotaExceededDialog();
  };

  return {
    searchQuotaExceededDialog,
    handleCloseSearchQuotaExceededDialog,
    handleOpenSearchQuotaExceededAccountManagement,
  };
};

export default useSearchQuotaExceededDialog;
